import React from 'react';
import BotInputControl from './ctrl_input';
import Button from '../../../../../../controls/button';

// import Logger from '../../../../../../../common/logger';

class BotRadiobuttonsControl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCheckbox: '',
            selectedCheckboxText: '',
            isInputValid: false
        };
    }

    onSubmit() {
        this.props.onSubmit({
            buttonId: this.state.selectedCheckbox,
            buttonText: this.state.selectedCheckboxText
        });
    }

    onClick(id, text) {
        if (this.props.enabled) {
            this.setState({
                selectedCheckbox: id,
                selectedCheckboxText: text,
                isInputValid: id ? true : false
            });
        }
    }

    render() {
        const radiobuttons = this.props.inputs
            ? this.props.inputs.map((input, i) => (
                <div key={i} className="botRadiobutton">
                    <BotInputControl
                        id={'radio' + input.id}
                        type="radio"
                        name="inputs"
                        label={input.text}
                        enabled={this.props.enabled}
                        checked={this.state.selectedCheckbox == input.id ? true : false}
                        onClick={() => this.onClick(input.id, input.text)}
                    />
                </div>
            ))
            : null;

        return (
            <div className="botRadiobuttons">
                {
                    <div>
                        {radiobuttons}
                        <Button
                            className="white"
                            disabled={!(this.props.enabled && this.state.isInputValid)}
                            text="Wybierz"
                            onClick={() => this.onSubmit()}
                        />
                    </div>
                }
            </div>
        );
    }
}

export default BotRadiobuttonsControl;
